var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CustomerDetailsBL } from "../CustomerInvoice/CustomerDetailsBL";
import "../CustomerInvoice/OrderCreate.css";
import { IS_SHIPPING_ADDRESS } from "../Constant";
import { useEffect, useMemo, useState } from "react";
import { SharedFunctions } from "../SharedFunctions";
import { CommonMethods } from "../MyCompany/CommonMethods";
export function CommonB2BAddressModalBL(props) {
    var _this = this;
    var _a = CustomerDetailsBL(), t = _a.t, errors = _a.errors;
    var _b = SharedFunctions(), getCountriesList = _b.getCountriesList, SnackbarAlertMsg = _b.SnackbarAlertMsg;
    var _c = CommonMethods(), SearchByCountry = _c.SearchByCountry, getDefaultAddress = _c.getDefaultAddress;
    var _d = useState({ msg: "", open: false }), triggerSnackbar = _d[0], settriggerSnackbar = _d[1];
    var _e = useState(false), isSavingAddress = _e[0], setIsSavingAddress = _e[1];
    var _f = useState(getDefaultAddress), customerDefaultAddress = _f[0], setCustomerDefaultAddress = _f[1];
    var REQUIRED_ADDRESS_FIELDS = ["address1", "country", "province", "city", "zipNumber"];
    useEffect(function () {
        getSelectedAddressPreviousValue();
    }, []);
    var getSelectedAddressPreviousValue = function () {
        var formData = props.formData, addressType = props.addressType;
        var addressData = addressType === IS_SHIPPING_ADDRESS ? formData === null || formData === void 0 ? void 0 : formData.ShippingAddress : formData === null || formData === void 0 ? void 0 : formData.BillingAddress;
        setCustomerDefaultAddress({
            firstName: (addressData === null || addressData === void 0 ? void 0 : addressData.firstName) || "",
            lastName: (addressData === null || addressData === void 0 ? void 0 : addressData.lastName) || "",
            address1: (addressData === null || addressData === void 0 ? void 0 : addressData.address1) || "",
            address2: (addressData === null || addressData === void 0 ? void 0 : addressData.address2) || "",
            country: (addressData === null || addressData === void 0 ? void 0 : addressData.country) || "",
            province: (addressData === null || addressData === void 0 ? void 0 : addressData.province) || "",
            city: (addressData === null || addressData === void 0 ? void 0 : addressData.city) || "",
            zipNumber: (addressData === null || addressData === void 0 ? void 0 : addressData.zipNumber) || "",
            companyName: (addressData === null || addressData === void 0 ? void 0 : addressData.companyName) || "",
            mobileNumber: (addressData === null || addressData === void 0 ? void 0 : addressData.mobileNumber) || "",
            countryCode: (addressData === null || addressData === void 0 ? void 0 : addressData.countryCode) || "",
            countriesStateData: (addressData === null || addressData === void 0 ? void 0 : addressData.countriesStateData) || [],
        });
    };
    var handleCloseSnackbar = function (event, reason) {
        if (reason === "clickaway") {
            return;
        }
        settriggerSnackbar({ msg: "", open: false });
    };
    var getSelectedAddressValue = function (key) {
        var formData = props.formData, addressType = props.addressType;
        var addressData = addressType === IS_SHIPPING_ADDRESS ? formData === null || formData === void 0 ? void 0 : formData.ShippingAddress : formData === null || formData === void 0 ? void 0 : formData.BillingAddress;
        return (addressData === null || addressData === void 0 ? void 0 : addressData[key]) || "";
    };
    var updateAddressField = function (key, value) {
        props.setCompanyInfo(function (prevFormData) {
            var _a, _b;
            return (__assign(__assign({}, prevFormData), (_a = {}, _a[(props === null || props === void 0 ? void 0 : props.addressType) === IS_SHIPPING_ADDRESS ? "ShippingAddress" : "BillingAddress"] = __assign(__assign({}, prevFormData[(props === null || props === void 0 ? void 0 : props.addressType) === IS_SHIPPING_ADDRESS ? "ShippingAddress" : "BillingAddress"]), (_b = {}, _b[key] = value, _b)), _a)));
        });
    };
    var handleClearModalPopUp = function () {
        var addressKey = props.addressType === IS_SHIPPING_ADDRESS ? "ShippingAddress" : "BillingAddress";
        props.setCompanyInfo(function (prevFormData) {
            var _a;
            return (__assign(__assign({}, prevFormData), (_a = {}, _a[addressKey] = __assign({}, customerDefaultAddress), _a)));
        });
        props === null || props === void 0 ? void 0 : props.closeModal();
    };
    var checkValidationOnSave = function () { return __awaiter(_this, void 0, void 0, function () {
        var addressKey, addressData, fieldLabels, emptyFields, missingFields, result, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    addressKey = (props === null || props === void 0 ? void 0 : props.addressType) === IS_SHIPPING_ADDRESS ? "ShippingAddress" : "BillingAddress";
                    addressData = props === null || props === void 0 ? void 0 : props.formData[addressKey];
                    fieldLabels = {
                        address1: t("myCustomers_table2Row3"),
                        country: t("Customer_Resion"),
                        province: t("addCustomer_customerState"),
                        city: t("customerInvoice_enterCityPlaceholder"),
                        zipNumber: t("Customer_pinCode"),
                    };
                    if (addressKey === "ShippingAddress") {
                        try {
                            emptyFields = REQUIRED_ADDRESS_FIELDS === null || REQUIRED_ADDRESS_FIELDS === void 0 ? void 0 : REQUIRED_ADDRESS_FIELDS.filter(function (field) { var _a; return !((_a = addressData === null || addressData === void 0 ? void 0 : addressData[field]) === null || _a === void 0 ? void 0 : _a.trim()); });
                            if ((emptyFields === null || emptyFields === void 0 ? void 0 : emptyFields.length) > 0) {
                                missingFields = (_a = emptyFields === null || emptyFields === void 0 ? void 0 : emptyFields.map(function (field) { return fieldLabels[field]; })) === null || _a === void 0 ? void 0 : _a.join(", ");
                                settriggerSnackbar({
                                    msg: "".concat(t("Please fill all required fields"), ": ").concat(missingFields),
                                    open: true,
                                    severity: "warning",
                                });
                                return [2 /*return*/];
                            }
                        }
                        catch (error) {
                            console.error("Error during validation:", error);
                            settriggerSnackbar({
                                msg: t("An error occurred during validation. Please try again."),
                                open: true,
                                severity: "error",
                            });
                            return [2 /*return*/];
                        }
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, 6, 7]);
                    setIsSavingAddress(true);
                    if (!((props === null || props === void 0 ? void 0 : props.isEditAddress) && (props === null || props === void 0 ? void 0 : props.onSaveAddress))) return [3 /*break*/, 3];
                    return [4 /*yield*/, (props === null || props === void 0 ? void 0 : props.onSaveAddress(addressKey))];
                case 2:
                    result = _b.sent();
                    if (result === true) {
                        props === null || props === void 0 ? void 0 : props.closeModal();
                    }
                    else {
                        props === null || props === void 0 ? void 0 : props.closeModal();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    props === null || props === void 0 ? void 0 : props.closeModal();
                    if (props === null || props === void 0 ? void 0 : props.saveAddressData) {
                        props === null || props === void 0 ? void 0 : props.saveAddressData(addressKey);
                    }
                    _b.label = 4;
                case 4: return [3 /*break*/, 7];
                case 5:
                    error_1 = _b.sent();
                    console.error("Unexpected Save Error:", error_1);
                    return [3 /*break*/, 7];
                case 6:
                    setIsSavingAddress(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var getIsRequired = function (fieldName) {
        try {
            // Only make fields required for shipping address
            if (!fieldName || (props === null || props === void 0 ? void 0 : props.addressType) !== IS_SHIPPING_ADDRESS) {
                return false;
            }
            // Required fields for shipping address
            return REQUIRED_ADDRESS_FIELDS.includes(fieldName);
        }
        catch (error) {
            console.error("Error in getIsRequired:", error);
            return false;
        }
    };
    var isSaveDisabled = useMemo(function () {
        var _a;
        try {
            if (props.addressType === IS_SHIPPING_ADDRESS) {
                var addressData_1 = (_a = props.formData) === null || _a === void 0 ? void 0 : _a.ShippingAddress;
                return REQUIRED_ADDRESS_FIELDS.every(function (field) { var _a; return !((_a = addressData_1 === null || addressData_1 === void 0 ? void 0 : addressData_1[field]) === null || _a === void 0 ? void 0 : _a.trim()); });
            }
            return false;
        }
        catch (error) {
            console.error("Error in isSaveDisabled:", error);
            return false;
        }
    }, [props.formData, props.addressType]);
    return {
        t: t,
        errors: errors,
        getCountriesList: getCountriesList,
        SnackbarAlertMsg: SnackbarAlertMsg,
        SearchByCountry: SearchByCountry,
        triggerSnackbar: triggerSnackbar,
        isSavingAddress: isSavingAddress,
        handleCloseSnackbar: handleCloseSnackbar,
        getSelectedAddressValue: getSelectedAddressValue,
        updateAddressField: updateAddressField,
        handleClearModalPopUp: handleClearModalPopUp,
        checkValidationOnSave: checkValidationOnSave,
        isSaveDisabled: isSaveDisabled,
        getIsRequired: getIsRequired,
    };
}
